/* components/ui/Modal.jsx — универсальный хром модального окна (без доменного контента).
   Размеры xs/sm/md/lg/xl. На мобильной полосе (xs, ≤719.98px) → fullscreen sheet
   (медиа-правило в components.css, согласовано с Drawer).
   focus-trap, body-scroll-lock, ESC, backdrop-click.
   Пропсы zIndex/role/autoFocusSelector — для надстроек (ConfirmProvider: role=alertdialog, z-confirm).
   Слоты: title + onClose | children (body) | footer (footerLeft + actions). */

import React from 'react';
import ReactDOM from 'react-dom';
import { Icon } from './Icon.jsx';
import { getOverlayRoot, overlay } from '../../lib/overlay.jsx';

  const { useRef } = React;
  const { useFocusTrap, useScrollLock } = overlay;

  function Modal({ open, onClose, title, size = 'md', children, footer, footerLeft,
                   closeOnBackdrop = true, labelledBy, zIndex = 'var(--z-modal)',
                   role = 'dialog', autoFocusSelector, className }) {
    const panelRef = useRef(null);
    useScrollLock(open);
    useFocusTrap(panelRef, { active: open, onEscape: onClose, autoFocusSelector });
    if (!open) return null;

    return ReactDOM.createPortal(
      <div className="overlay overlay--modal" style={{ zIndex }}>
        <div className="overlay__backdrop" onClick={closeOnBackdrop ? onClose : undefined} />
        <div className={`modal modal--${size}` + (className ? ' ' + className : '')} role={role} aria-modal="true"
             aria-labelledby={labelledBy} ref={panelRef}>
          {(title || onClose) && (
            <div className="modal__head">
              <h2 className="modal__title t-h3" id={labelledBy}>{title}</h2>
              <button className="modal__close" onClick={onClose} aria-label="Закрыть">
                <Icon name="close" size={18} />
              </button>
            </div>
          )}
          <div className="modal__body">{children}</div>
          {(footer || footerLeft) && (
            <div className="modal__foot">
              <div className="modal__foot-left">{footerLeft}</div>
              <div className="modal__foot-actions cluster cluster-4">{footer}</div>
            </div>
          )}
        </div>
      </div>,
      getOverlayRoot()
    );
  }

export { Modal };
